import React from "react";
import '../styles/roles.css';
import TiltCard from './TiltCard';

const RolesSection = ({ onOpenSignup }) => {
  const roles = [
    {
      type: "buyer", label: "Buyer",
      tagBg: "var(--secondary)", tagColor: "var(--secondary-foreground)",
      iconBg: "var(--secondary)", icon: "🔍",
      title: "Browse & Buy",
      desc: "Sign up for free and start browsing thousands of vehicles immediately. Save favourites, chat with sellers and get price-drop alerts, all from your phone.",
      steps: ["Download the app & create a free account", "Browse by city, category, price or model", "Save favourites & set price-drop alerts", "Chat with sellers & close the deal"],
      stepBg: "var(--secondary)", stepColor: "var(--secondary-foreground)",
      ctaBg: "var(--secondary)", ctaColor: "var(--secondary-foreground)",
      ctaText: "Start Browsing →",
      topBar: "linear-gradient(to right,var(--primary),var(--green-mid))",
      defaultBadge: true,
    },
    {
      type: "seller", label: "Seller",
      tagBg: "var(--orange-light)", tagColor: "var(--orange-dark)",
      iconBg: "var(--orange-light)", icon: "🏷️",
      title: "List & Sell",
      desc: "Want to sell your vehicle? Upgrade to Seller inside the app. Complete a quick KYC to earn your Verified badge and reach thousands of active buyers.",
      steps: ['Tap "Become a Seller" in your profile', "Submit NRC & selfie for KYC verification", "Get approved & earn your Verified badge", "List your vehicle & start receiving offers"],
      stepBg: "var(--orange-light)", stepColor: "var(--orange-dark)",
      ctaBg: "var(--orange-light)", ctaColor: "var(--orange-dark)",
      ctaText: "Become a Seller →",
      topBar: "linear-gradient(to right,var(--accent),var(--orange-mid))",
    },
    {
      type: "dealer", label: "Dealer",
      tagBg: "var(--dealer-light)", tagColor: "var(--dealer)",
      iconBg: "var(--dealer-light)", icon: "🏢",
      title: "Deal at Scale",
      desc: "A professional dealer account gives you bulk listing tools, business verification, a dealer profile page, and priority placement in search results.",
      steps: ['Tap "Become a Dealer" in your profile', "Submit business registration & NRC", "Complete dealer KYC & business review", "Get a verified Dealer page & bulk tools"],
      stepBg: "var(--dealer-light)", stepColor: "var(--dealer)",
      ctaBg: "var(--dealer-light)", ctaColor: "var(--dealer)",
      ctaText: "Apply as Dealer →",
      topBar: "linear-gradient(to right,var(--dealer),#818cf8)",
    },
  ];

  return (
    <section className="roles" id="roles">
      <div className="container">
        <span className="section-tag animate-on-scroll">👤 Features</span>
        <h2 className="section-title animate-on-scroll">One App, Three Powerful Roles</h2>
        <p className="section-desc animate-on-scroll">Everyone starts as a Buyer. Upgrade to Seller or Dealer any time inside the app.</p>
        <div className="roles-grid stagger-children">
          {roles.map((r) => (
            <TiltCard className={`role-card ${r.type} animate-on-scroll`} key={r.type} max={7} scale={1.03}>
              <div className="top-bar" style={{ background: r.topBar }}></div>
              <div className="role-tag-row">
                <span className="role-tag" style={{ background: r.tagBg, color: r.tagColor }}>{r.label}</span>
                {r.defaultBadge && <span className="default-badge">Default</span>}
              </div>
              <div className="role-icon" style={{ background: r.iconBg }}>{r.icon}</div>
              <h3>{r.title}</h3>
              <p className="role-desc">{r.desc}</p>
              <div className="role-steps">
                {r.steps.map((s, j) => (
                  <div className="role-step" key={j}>
                    <span className="step-num" style={{ background: r.stepBg, color: r.stepColor }}>{j + 1}</span>
                    <span>{s}</span>
                  </div>
                ))}
              </div>
              <button className="role-cta" style={{ background: r.ctaBg, color: r.ctaColor }} onClick={onOpenSignup}>
                {r.ctaText}
              </button>
            </TiltCard>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RolesSection;